const actions = {
  analyticsOnVisitedCalendar: (context) => {
    if (window.$crisp) {
      window.$crisp.push(['set', 'session:event', [[
        ['do_visited_calendar']
      ]]])
    }
  },
  analyticsOnVisitedBuy: (context) => {
    if (window.$crisp) {
      window.$crisp.push(['set', 'session:event', [[
        ['do_visited_buy']
      ]]])
    }
  },
  analyticsOnSubscribe: (context) => {
    if (window.$crisp) {
      window.$crisp.push(['set', 'session:event', [[
        ['do_subscribed']
      ]]])
    }
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {})
    }
  },
  analyticsCopyCalender: (context) => {
    if (window.$crisp) {
      window.$crisp.push(['set', 'session:event', [[
        ['do_visited_buy']
      ]]])
    }
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js